export enum AccessType {
    ContentManagement = 'content-management'
}